export default "__VITE_ASSET__DdaZ9HNo__"